import { render, staticRenderFns } from "./TakingEditInfo.vue?vue&type=template&id=840ef1aa"
import script from "./TakingEditInfo.vue?vue&type=script&lang=js"
export * from "./TakingEditInfo.vue?vue&type=script&lang=js"
import style0 from "./TakingEditInfo.vue?vue&type=style&index=0&id=840ef1aa&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports